import React, { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { CalendarIcon, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Calendar } from '../ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';

// Calendar date picker; value/onChange use 'YYYY-MM-DD' strings ('' = unset).
export const DatePickerField = ({ value, onChange, placeholder = 'Pick a date', testId, className = 'w-[160px]', min, max }) => {
  const selected = value ? parseISO(value) : undefined;
  const [open, setOpen] = useState(false);
  const disabled = [...(min ? [{ before: parseISO(min) }] : []), ...(max ? [{ after: parseISO(max) }] : [])];
  return (
    <div className="flex items-center gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className={`${className} justify-start font-normal ${value ? '' : 'text-muted-foreground'}`} data-testid={testId}>
            <CalendarIcon className="w-4 h-4 mr-2" />{selected ? format(selected, 'd MMM yyyy') : placeholder}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" selected={selected} defaultMonth={selected} disabled={disabled}
                    onSelect={(d) => { if (d) onChange(format(d, 'yyyy-MM-dd')); setOpen(false); }} initialFocus />
        </PopoverContent>
      </Popover>
      {value && (
        <Button variant="ghost" size="icon" className="h-8 w-8" onClick={() => onChange('')} aria-label="Clear date" data-testid={testId ? `${testId}-clear` : undefined}>
          <X className="w-3.5 h-3.5" />
        </Button>
      )}
    </div>
  );
};
